export default __webpack_public_path__ + "static/media/ARS.597c605b.png";